// Docs: https://github.com/WorkpathHQ/workpath_web/wiki/Container-Constants-Docs
export const GET_KEY_RESULT_PROGRESS_OVER_TIME_REQUEST =
  'app/KeyResultProgressOverTimeModal/GET_KEY_RESULT_PROGRESS_OVER_TIME_REQUEST';
export const GET_KEY_RESULT_PROGRESS_OVER_TIME_SUCCESS =
  'app/KeyResultProgressOverTimeModal/GET_KEY_RESULT_PROGRESS_OVER_TIME_SUCCESS';
export const GET_KEY_RESULT_PROGRESS_OVER_TIME_ERROR =
  'app/KeyResultProgressOverTimeModal/GET_KEY_RESULT_PROGRESS_OVER_TIME_ERROR';
